import { useQuery } from '@tanstack/react-query';
import { mastraClient } from '@/lib/mastra-client';

export interface InvoiceMemoryResult {
  workingMemory: string | null;
  threadExists?: boolean;
}

export function useInvoiceMemory(invoiceNumber: string, enabled: boolean) {
  return useQuery<InvoiceMemoryResult>({
    queryKey: ['aging', 'invoice-memory', invoiceNumber],
    queryFn: async (): Promise<InvoiceMemoryResult> => {
      const raw: unknown = await mastraClient.getWorkingMemory({
        agentId: 'acc-accounts-receivable',
        threadId: `invoice-${invoiceNumber}`,
        resourceId: 'invoice-reconciliation',
      });
      if (typeof raw !== 'object' || raw === null) {
        return { workingMemory: null, threadExists: false };
      }
      const r = raw as Record<string, unknown>;
      return {
        workingMemory: typeof r.workingMemory === 'string' ? r.workingMemory : null,
        threadExists: 'threadExists' in r ? Boolean(r.threadExists) : undefined,
      };
    },
    enabled: enabled && !!invoiceNumber,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
